module.exports = __webpack_public_path__ + "img/fase-1.d61b9ff5.svg";